import { useEffect, useState } from "react";
import { Page } from "../../../components/page-base";
import { Input } from "../../../components/inputs";
import {
  AccountSelectContainer,
  BtnsContainer,
  ContainerCriterio,
  FormContainerGrid,
  IconContainer,
  ScenarioContainer,
  TitleInput,
  TopCardsContainer,
} from "./styles";
import {
  Add,
  ViewListOutlined,
  ModeEditOutlineOutlined,
} from "@mui/icons-material";
import isMobile from "is-mobile";
import { toast } from "react-toastify";
import { ScenariosService } from "../services";
import {
  TParticipation,
  TScenario,
  TScenarioFormState,
  TSelectAccounts,
} from "../models";
import { useAuthContext, useNavigationContext } from "../../../contexts";
import theme from "../../../styles/theme";
import { AccountsService } from "../../accounts/services";
import { TAccount, TAccountRes } from "../../accounts/models";
import permissionsStore from "../../../store/permissions";
import { ScenarioCardsDisplay } from "../components/scenario-cards-display";
import {
  NoScenario,
  OracleContainer,
} from "../components/scenario-item/styles";
import { ScenarioItem } from "../components/scenario-item";
import { Tooltip } from "@mui/material";
import { setDefaultScenario, updateScenarioId } from "@/utils/setDefaultScenario";

export const Scenarios: React.FC = () => {
  const defaultCriterio: TScenarioFormState[] = [
    {
      id: 1,
      label: "Considerar esfera Criminal na reprovação",
      isEnabled: false,
      participation: { ativo: false, reu: false, citado: false },
    },
    {
      id: 2,
      label: "Considerar esfera Trabalhista na reprovação",
      isEnabled: false,
      participation: { ativo: false, reu: false, citado: false },
    },
    {
      id: 3,
      label: "Considerar esfera Cível na reprovação",
      isEnabled: false,
      participation: { ativo: false, reu: false, citado: false },
    },
    {
      id: 4,
      label: "Considerar esfera Eleitoral na reprovação",
      isEnabled: false,
      participation: { ativo: false, reu: false, citado: false },
    },
  ];
  const [defaultScenariosForm, setDefaultScenariosForm] =
    useState<TScenarioFormState[]>(defaultCriterio);

  const { user } = useAuthContext();
  const { selectedAccountCombo, setSelectedAccountCombo, defaultCriterioId } =
    useNavigationContext();
  const { role, setAccountId, storageUser, scenarioId, setScenarioId } =
    permissionsStore();

  const [scenarios, setScenarios] = useState<TScenario[]>([]);
  const [tab, setTab] = useState<number>(1);
  const [accountsOptions, setAccountOptions] = useState<TSelectAccounts[]>([]);
  const [titlePrompt, setTitlePrompt] = useState<string>("");
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [, setModal] = useState<boolean>(false);
  const [credits, setCredits] = useState<number>(0);

  const fetchData = async () => {
    await ScenariosService.getScenarios(1, selectedAccountCombo!)
      .then((scenariosRes) => {
        if (scenariosRes && scenariosRes.data) {
          setScenarios(scenariosRes.data as TScenario[]);
          checkCriterioCreate(scenariosRes.data as TScenario[]);
        } else {
          setScenarios([]);
          toast.error("Erro ao consultar Critérios");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (selectedAccountCombo) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAccountCombo, defaultCriterioId]);

  // Busca todas as contas para popular o select de contas
  const fetchAllAccounts = async () => {
    const allAccounts: TAccount[] = [];
    let page = 1;
    let total = 0;

    try {
      do {
        const response: TAccountRes | null = await AccountsService.getAccounts(
          page,
          "",
          100
        );
        if (response && response.data && Array.isArray(response.data)) {
          allAccounts.push(...response.data);
        }
        if (response && response.meta) {
          total = response.meta.total;
        } else {
          total = 0;
        }
        page++;
      } while (allAccounts.length < total);

      if (allAccounts.length) {
        if (selectedAccountCombo) {
          const selected = allAccounts.find(
            (acc) => acc.id === selectedAccountCombo
          );
          setCredits(selected?.credits || 0);
          setSelectedAccountCombo(selected!.id);
        } else {
          const oldestAccount = allAccounts.reduce((oldest, current) => {
            return new Date(current.createdAt) < new Date(oldest.createdAt)
              ? current
              : oldest;
          });
          setCredits(oldestAccount?.credits);
          setSelectedAccountCombo(oldestAccount.id);
        }

        const options = allAccounts.map((acc) => ({
          value: acc.id.toString(),
          label: acc.name,
          payload: acc.credits,
        }));
        setAccountOptions(options);
      }
    } catch (error) {
      console.error("Erro ao buscar contas:", error);
      toast.error("Erro ao buscar contas.");
    }
  };

  useEffect(() => {
    fetchAllAccounts();
    /* eslint-disable-next-line */
  }, [user]);

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  /* eslint-disable-next-line */
  const handleChange = (e: any) => {
    setTitlePrompt(e.target.value);
  };

  const deparsePrompt = (prompt: TScenarioFormState[]) => {
    const esferaIndices: Record<number, string> = {
      0: "Criminal",
      1: "Trabalhista",
      2: "Cível",
      3: "Eleitoral",
    };

    const updatedPrompt = prompt
      .map((scenario, index) => {
        const { isEnabled, participation } = scenario;
        if (!isEnabled) return "";
        const promptString = `${esferaIndices[index]};${participation.ativo ? "ATIVO" : ""
          };${participation.reu ? "PASSIVO" : ""};${participation.citado ? "CITADO" : ""
          }`;
        return promptString.endsWith(";;;;true") ? "" : promptString;
      })
      .filter(Boolean)
      .join("\n")
      .trim();

    return updatedPrompt.replace(/^\s*[\r\n]/gm, "");
  };

  const onSubmit = async () => {
    try {
      const response = await ScenariosService.createScenario(
        titlePrompt,
        deparsePrompt(defaultScenariosForm),
        selectedAccountCombo!
      );

      if (response?.success) {
        fetchData();
        toast.success(response.message);
        setTab(1);
        resetForm();
      } else {
        toast.error(response?.message || "Erro ao criar critério.");
      }
    } catch (error) {
      toast.error("Ocorreu um erro ao criar o critério.");
      console.error("Erro ao criar critério:", error);
    }
  };

  // Função que restaura o estado do formulário para os valores default
  const resetForm = () => {
    setTitlePrompt("");
    setDefaultScenariosForm(defaultCriterio);
  };

  // Desfaz alterações
  const onCancel = () => {
    if (role !== "collaborator") {
      toast.warn("Alterações descartadas.");
    }
    resetForm();
    setTab(1);
  };

  const handleToggleEnabled = (cardId: number) => {
    setDefaultScenariosForm((prevScenarios) =>
      prevScenarios.map((scenario) =>
        scenario.id === cardId
          ? {
            ...scenario,
            isEnabled: !scenario.isEnabled,
            participation: { ativo: false, citado: false, reu: false },
          }
          : scenario
      )
    );
  };

  const handleToggleParticipation = (
    cardId: number,
    field: keyof TParticipation
  ) => {
    setDefaultScenariosForm((prevScenarios) =>
      prevScenarios.map((scenario) =>
        scenario.id === cardId
          ? {
            ...scenario,
            participation: {
              ...scenario.participation,
              [field]: !scenario.participation[field],
            },
          }
          : scenario
      )
    );
  };

  // Verificação para caso existam 2+ cenários e 0 créditos
  const checkCriterioCreate = (scenarios: TScenario[]) => {
    if (
      user?.userType == "COMPANY" &&
      scenarios.length == 1 &&
      !scenarios[0].prompt &&
      credits == 0
    ) {
      setModal(true);
    }
  };

  // Avança para tab de criação de critério
  const handleContinue = () => {
    setTab(2);
  };

  // Normaliza scenarioId para que seja um array de objetos { scenarioId, accountId }
  const normalizeScenarioId = () => {
    if (!Array.isArray(scenarioId)) {
      return [{ scenarioId, accountId: selectedAccountCombo }];
    }
    return scenarioId;
  };

  // Obtém o ID do critério selecionado (ou null) para a conta atual
  const getCriterioId = () => {
    const normalizedScenario = normalizeScenarioId();
    return normalizedScenario.find(
      (scenario) => scenario.accountId === selectedAccountCombo
    )?.scenarioId;
  };

  // Verifica se o critério atual (o que está em uso) tem prompt preenchido
  const validatePrompCurrentCriterio = () => {
    const havePrompt = scenarios.find((s) => s.id === getCriterioId());
    return havePrompt?.prompt ? true : false;
  };

  // Desabilita critério (volta para o 'padrão', sem prompt)
  const disableCriterio = async () => {
    const index = scenarios.findIndex((s) => s.prompt === null);
    if (index !== -1) {
      const result = await setDefaultScenario(selectedAccountCombo!, scenarios[index].id, storageUser!.id);
      if (result.success) {
        setScenarioId(updateScenarioId(selectedAccountCombo!, scenarioId, scenarios[index].id));
      } else {
        toast.error("Ocorreu um erro ao alterar o critério.");
      }
    } else {
      try {
        const response = await ScenariosService.createScenario(
          "Critério Padrão",
          null,
          selectedAccountCombo!
        );
        if (response.success) {
          toast.success(response.message);
          setScenarioId(
            updateScenarioId(selectedAccountCombo!, scenarioId, response.scenarioId!)
          );
          fetchData();
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error("Ocorreu um erro ao desabilitar critério.");
        console.error("Erro ao desabilitar critério", error);
      }
    }
  };

  // ---- LÓGICA DE HABILITAÇÃO DO BOTÃO SALVAR ----
  // Verifica se existe ao menos um cenário habilitado com participação
  const isAnyScenarioEnabled = defaultScenariosForm.some(
    (scenario) =>
      scenario.isEnabled &&
      (scenario.participation.ativo ||
        scenario.participation.reu ||
        scenario.participation.citado)
  );

  // Verifica se o título não está vazio
  const isTitlePromptFilled = titlePrompt.trim().length > 0;

  // Se não tem cenário válido OU o título está vazio, desabilita o botão
  const isButtonDisabled = !isAnyScenarioEnabled || !isTitlePromptFilled;

  return (
    <Page.Root>
      <Page.Header
        title="Critérios"
        key="scenarios"
        controlElement={[
          !isMobile() &&
          role !== "collaborator" && (
            <AccountSelectContainer key="account-select">
              <span className="label">Conta selecionada:</span>
              <Input.Select
                onChange={(newValue) => {
                  setSelectedAccountCombo(Number(newValue));
                  setAccountId(Number(newValue));
                }}
                selectedValue={selectedAccountCombo?.toString()}
                options={accountsOptions}
              />
            </AccountSelectContainer>
          ),
          <div style={{ width: "inherit" }} key="page-button">
            {role !== "collaborator" && scenarios.length > 1 && (
              <Page.Button
                label={
                  isMobile()
                    ? ""
                    : tab === 1
                      ? "Criar critério"
                      : "Lista de Critérios"
                }
                borderColor={theme.colors.palete.gold}
                disabled={false}
                startIcon={tab === 1 ? <Add /> : <ViewListOutlined />}
                onClick={() => {
                  if (tab === 1) {
                    setTab(2);
                  } else {
                    resetForm();
                    setTab(1);
                  }
                }}
              />
            )}
          </div>,
        ].filter(Boolean)}
      />

      {tab === 1 ? (
        <ScenarioContainer>
          {isMobile() && role !== "collaborator" && (
            <AccountSelectContainer key="account-select-mobile">
              <span className="label">Conta selecionada:</span>
              <Input.Select
                onChange={(newValue) => {
                  setSelectedAccountCombo(Number(newValue));
                  setAccountId(Number(newValue));
                }}
                selectedValue={selectedAccountCombo?.toString()}
                options={accountsOptions}
              />
            </AccountSelectContainer>
          )}
          <div style={{ display: "flex", placeContent: "center" }}>
            {loading ? (
              <span className="label-scenario">Carregando...</span>
            ) : scenarios.length >= 1 ? (
              <ContainerCriterio>
                <OracleContainer isActive={validatePrompCurrentCriterio()}>
                  {validatePrompCurrentCriterio() ? (
                    <>
                      <span className="status">
                        Análise com critério está ativada
                      </span>

                      <p className="description">
                        Ao clicar no botão, você pode desabilitar os critérios
                        de análise e os filtros para aprovar ou reprovar os
                        CPFs analisados não serão aplicados.
                      </p>
                      <div className="button-continue">
                        <Page.Button
                          type="button"
                          label="Desabilitar"
                          onClick={disableCriterio}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {scenarios.length === 1 ? (
                        <>
                          <span className="status">
                            Você não possui critérios cadastrados.
                          </span>
                          <p className="description">
                            Você pode criar critérios de análise e os filtros
                            para aprovar ou reprovar os CPFs analisados serão
                            aplicados.
                          </p>
                          <div
                            className="button-continue"
                            style={{ marginBottom: "0px" }}
                          >
                            <Page.Button
                              type="button"
                              label="Criar critério"
                              disabled={false}
                              startIcon={<Add />}
                              borderColor={theme.colors.palete.gold}
                              onClick={() => {
                                setTab(2);
                              }}
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <span className="status">
                            Análise com critério desativada
                          </span>
                          <p className="description">
                            Você pode ativar qualquer critério de análise e os
                            filtros para aprovar ou reprovar os CPFs
                            analisados serão aplicados.
                          </p>
                        </>
                      )}
                    </>
                  )}
                  <ScenarioItem
                    scenarios={scenarios}
                    selectedAccountId={selectedAccountCombo!}
                    fetchData={fetchData}
                  />
                </OracleContainer>
              </ContainerCriterio>
            ) : (
              <NoScenario>
                <span className="label-scenario">
                  Nenhum critério cadastrado.
                </span>
                <p className="description-scenario">
                  Ao clicar no botão, você pode criar critérios de análise e
                  concorda que serão aplicados filtros para aprovar ou
                  reprovar os CPFs analisados.
                </p>
                <div className="button-continue">
                  <Page.Button
                    type="button"
                    label="Continuar"
                    onClick={handleContinue}
                  />
                </div>
              </NoScenario>
            )}
          </div>
        </ScenarioContainer>
      ) : (
        <FormContainerGrid>
          <span className="form-title" style={{ marginTop: "4vh" }}>
            Cadastro de Critério
          </span>
          <TopCardsContainer>
            <Tooltip title="Clique para alterar" arrow placement="top-start">
              <div className="input-container">
                <IconContainer
                  isHovered={isHovered}
                  isFocused={isFocused}
                  isEmpty={!titlePrompt.trim()}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <ModeEditOutlineOutlined sx={{ color: "white" }} />
                </IconContainer>
                <TitleInput
                  placeholder="Informe o título para o critério"
                  value={titlePrompt}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  isEmpty={!titlePrompt.trim()}
                  readOnly={role === "collaborator"}
                />
              </div>
            </Tooltip>
          </TopCardsContainer>
          <ScenarioCardsDisplay
            onToggleParticipation={handleToggleParticipation}
            onToggleEnabled={handleToggleEnabled}
            scenariosForm={defaultScenariosForm}
            scenarioId={0}
          />
          <BtnsContainer style={{ marginTop: "2vh", marginBottom: "4vh" }}>
            <Page.Button
              type="reset"
              disabled={false}
              onClick={onCancel}
              label="Cancelar"
              bgColor={theme.colors.palete.gold}
            />
            {role !== "collaborator" && (
              <Page.Button
                label="Salvar"
                type="button"
                onClick={onSubmit}
                bgColor={theme.colors.palete.gold}
                disabled={isButtonDisabled}
              />
            )}
          </BtnsContainer>
        </FormContainerGrid>
      )}
    </Page.Root>
  );
};
